import { Column } from "@hightouch/htui";

import { Page } from "src/components/layout";
import { Navigate, NoContextOutlet } from "src/router";
import { useIsHightouchUser } from "src/utils/is-hightouch-user";

/**
 * Gate for every route under `/admin-tools`. Tools nested here don't need
 * their own employee check — this layout owns it.
 */
export const AdminToolsLayout = () => {
  const isHightouchUser = useIsHightouchUser();

  if (!isHightouchUser) {
    return <Navigate to="/" replace />;
  }

  return (
    <Page
      title="Admin tools"
      heading="Admin tools"
      crumbs={[{ label: "Admin tools" }]}
    >
      <Column maxWidth="3xl" minH={0}>
        <NoContextOutlet />
      </Column>
    </Page>
  );
};
